// source: icc.info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var icc_search_pb = require('./icc.search_pb.js');
goog.object.extend(proto, icc_search_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.displayName = 'proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
slug: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
accessLevel: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAccessLevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string access_level = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.prototype.getAccessLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.prototype.setAccessLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.toObject = function(includeInstance, msg) {
  var f, obj = {
canAnnotate: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
canCpp: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
canCppPremium: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanAnnotate(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanCpp(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanCppPremium(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanAnnotate();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCanCpp();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCanCppPremium();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional bool can_annotate = 1;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.getCanAnnotate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.setCanAnnotate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool can_cpp = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.getCanCpp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.setCanCpp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool can_cpp_premium = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.getCanCppPremium = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.prototype.setCanCppPremium = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.repeatedFields_ = [13,14,30];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
documentSlug: jspb.Message.getFieldWithDefault(msg, 2, ""),
documentId: jspb.Message.getFieldWithDefault(msg, 3, 0),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
displayTitle: jspb.Message.getFieldWithDefault(msg, 5, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 6, ""),
abbreviation: jspb.Message.getFieldWithDefault(msg, 7, ""),
iccAbbreviation: jspb.Message.getFieldWithDefault(msg, 8, ""),
bookShortCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
sku: jspb.Message.getFieldWithDefault(msg, 10, ""),
pdfUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
shopUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
bookCategoriesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
categorySlugList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
documentUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
documentType: (f = msg.getDocumentType()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.toObject(includeInstance, f),
contentType: (f = msg.getContentType()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.toObject(includeInstance, f),
documentStatus: (f = msg.getDocumentStatus()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.toObject(includeInstance, f),
isFreeTrial: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
isFeatured: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
isXml: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
isAstm: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
isPremiumPdf: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
isCollection: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
imageUrl: jspb.Message.getFieldWithDefault(msg, 25, ""),
printInfo: jspb.Message.getFieldWithDefault(msg, 26, ""),
bookYear: jspb.Message.getFieldWithDefault(msg, 27, ""),
access: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
newIccxml: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
categoriesList: jspb.Message.toObjectList(msg.getCategoriesList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.toObject, includeInstance),
link: jspb.Message.getFieldWithDefault(msg, 31, ""),
subscriptionRequired: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
masterDocumentId: jspb.Message.getFieldWithDefault(msg, 33, 0),
sortOrder: jspb.Message.getFieldWithDefault(msg, 34, 0),
printVersionMonth: jspb.Message.getFieldWithDefault(msg, 35, ""),
documentCoverPdf: jspb.Message.getFieldWithDefault(msg, 36, ""),
isLatestVersion: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
latestVersionId: jspb.Message.getFieldWithDefault(msg, 38, 0),
servePdfToBrowser: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
year: (f = msg.getYear()) && icc_search_pb.PrintVersionYear.toObject(includeInstance, f),
printVersionYear: (f = msg.getPrintVersionYear()) && icc_search_pb.PrintVersionYear.toObject(includeInstance, f),
printVersionEdition: (f = msg.getPrintVersionEdition()) && icc_search_pb.PrintVersionEdition.toObject(includeInstance, f),
associateSortOrder: jspb.Message.getFieldWithDefault(msg, 43, 0),
customToc: jspb.Message.getBooleanFieldWithDefault(msg, 44, false),
customTocContent: jspb.Message.getFieldWithDefault(msg, 45, ""),
documentKeywords: jspb.Message.getFieldWithDefault(msg, 46, ""),
bookAbbr: jspb.Message.getFieldWithDefault(msg, 47, ""),
description: jspb.Message.getFieldWithDefault(msg, 48, ""),
effectiveDate: jspb.Message.getFieldWithDefault(msg, 49, ""),
titleTopic: (f = msg.getTitleTopic()) && icc_search_pb.TitleTopic.toObject(includeInstance, f),
isMasterBook: jspb.Message.getBooleanFieldWithDefault(msg, 51, false),
contentAccessLevel: (f = msg.getContentAccessLevel()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.toObject(includeInstance, f),
printingText: jspb.Message.getFieldWithDefault(msg, 53, ""),
partOfComplete: jspb.Message.getBooleanFieldWithDefault(msg, 54, false),
isExcluded: jspb.Message.getBooleanFieldWithDefault(msg, 55, false),
hasLandingPage: jspb.Message.getBooleanFieldWithDefault(msg, 56, false),
supportsVersions: jspb.Message.getBooleanFieldWithDefault(msg, 57, false),
recentlyAdded: jspb.Message.getBooleanFieldWithDefault(msg, 58, false),
contentAccessLevelId: jspb.Message.getFieldWithDefault(msg, 59, 0),
customCodeProfileLabel: jspb.Message.getFieldWithDefault(msg, 60, ""),
contentRestricted: jspb.Message.getBooleanFieldWithDefault(msg, 61, false),
accessOutsideTrial: jspb.Message.getBooleanFieldWithDefault(msg, 62, false),
contentBasic: jspb.Message.getFieldWithDefault(msg, 63, 0),
contentPremium: jspb.Message.getFieldWithDefault(msg, 64, 0),
contentProtection: jspb.Message.getFieldWithDefault(msg, 65, 0),
contentAccess: (f = msg.getContentAccess()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentSlug(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDocumentId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayTitle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbbreviation(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccAbbreviation(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookShortCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPdfUrl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addBookCategories(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategorySlug(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentUrl(value);
      break;
    case 16:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.deserializeBinaryFromReader);
      msg.setDocumentType(value);
      break;
    case 17:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.deserializeBinaryFromReader);
      msg.setContentType(value);
      break;
    case 18:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.deserializeBinaryFromReader);
      msg.setDocumentStatus(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFreeTrial(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFeatured(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsXml(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAstm(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPremiumPdf(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCollection(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrintInfo(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookYear(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccess(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewIccxml(value);
      break;
    case 30:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.deserializeBinaryFromReader);
      msg.addCategories(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubscriptionRequired(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterDocumentId(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrintVersionMonth(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentCoverPdf(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLatestVersion(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLatestVersionId(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setServePdfToBrowser(value);
      break;
    case 40:
      var value = new icc_search_pb.PrintVersionYear;
      reader.readMessage(value,icc_search_pb.PrintVersionYear.deserializeBinaryFromReader);
      msg.setYear(value);
      break;
    case 41:
      var value = new icc_search_pb.PrintVersionYear;
      reader.readMessage(value,icc_search_pb.PrintVersionYear.deserializeBinaryFromReader);
      msg.setPrintVersionYear(value);
      break;
    case 42:
      var value = new icc_search_pb.PrintVersionEdition;
      reader.readMessage(value,icc_search_pb.PrintVersionEdition.deserializeBinaryFromReader);
      msg.setPrintVersionEdition(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssociateSortOrder(value);
      break;
    case 44:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomToc(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomTocContent(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentKeywords(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookAbbr(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setEffectiveDate(value);
      break;
    case 50:
      var value = new icc_search_pb.TitleTopic;
      reader.readMessage(value,icc_search_pb.TitleTopic.deserializeBinaryFromReader);
      msg.setTitleTopic(value);
      break;
    case 51:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMasterBook(value);
      break;
    case 52:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.deserializeBinaryFromReader);
      msg.setContentAccessLevel(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrintingText(value);
      break;
    case 54:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPartOfComplete(value);
      break;
    case 55:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExcluded(value);
      break;
    case 56:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasLandingPage(value);
      break;
    case 57:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsVersions(value);
      break;
    case 58:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecentlyAdded(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentAccessLevelId(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomCodeProfileLabel(value);
      break;
    case 61:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContentRestricted(value);
      break;
    case 62:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccessOutsideTrial(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentBasic(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentPremium(value);
      break;
    case 65:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentProtection(value);
      break;
    case 66:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.deserializeBinaryFromReader);
      msg.setContentAccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDocumentSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDocumentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIccAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBookShortCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPdfUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getShopUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBookCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getCategorySlugList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getDocumentUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDocumentType();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType.serializeBinaryToWriter
    );
  }
  f = message.getContentType();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType.serializeBinaryToWriter
    );
  }
  f = message.getDocumentStatus();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus.serializeBinaryToWriter
    );
  }
  f = message.getIsFreeTrial();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getIsFeatured();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getIsXml();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getIsAstm();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getIsPremiumPdf();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getIsCollection();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getPrintInfo();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getBookYear();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getAccess();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getNewIccxml();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      30,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory.serializeBinaryToWriter
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getSubscriptionRequired();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getMasterDocumentId();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      34,
      f
    );
  }
  f = message.getPrintVersionMonth();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getDocumentCoverPdf();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getIsLatestVersion();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getLatestVersionId();
  if (f !== 0) {
    writer.writeInt32(
      38,
      f
    );
  }
  f = message.getServePdfToBrowser();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getYear();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      icc_search_pb.PrintVersionYear.serializeBinaryToWriter
    );
  }
  f = message.getPrintVersionYear();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      icc_search_pb.PrintVersionYear.serializeBinaryToWriter
    );
  }
  f = message.getPrintVersionEdition();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      icc_search_pb.PrintVersionEdition.serializeBinaryToWriter
    );
  }
  f = message.getAssociateSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      43,
      f
    );
  }
  f = message.getCustomToc();
  if (f) {
    writer.writeBool(
      44,
      f
    );
  }
  f = message.getCustomTocContent();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getDocumentKeywords();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getBookAbbr();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getEffectiveDate();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getTitleTopic();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      icc_search_pb.TitleTopic.serializeBinaryToWriter
    );
  }
  f = message.getIsMasterBook();
  if (f) {
    writer.writeBool(
      51,
      f
    );
  }
  f = message.getContentAccessLevel();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel.serializeBinaryToWriter
    );
  }
  f = message.getPrintingText();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getPartOfComplete();
  if (f) {
    writer.writeBool(
      54,
      f
    );
  }
  f = message.getIsExcluded();
  if (f) {
    writer.writeBool(
      55,
      f
    );
  }
  f = message.getHasLandingPage();
  if (f) {
    writer.writeBool(
      56,
      f
    );
  }
  f = message.getSupportsVersions();
  if (f) {
    writer.writeBool(
      57,
      f
    );
  }
  f = message.getRecentlyAdded();
  if (f) {
    writer.writeBool(
      58,
      f
    );
  }
  f = message.getContentAccessLevelId();
  if (f !== 0) {
    writer.writeInt32(
      59,
      f
    );
  }
  f = message.getCustomCodeProfileLabel();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getContentRestricted();
  if (f) {
    writer.writeBool(
      61,
      f
    );
  }
  f = message.getAccessOutsideTrial();
  if (f) {
    writer.writeBool(
      62,
      f
    );
  }
  f = message.getContentBasic();
  if (f !== 0) {
    writer.writeInt32(
      63,
      f
    );
  }
  f = message.getContentPremium();
  if (f !== 0) {
    writer.writeInt32(
      64,
      f
    );
  }
  f = message.getContentProtection();
  if (f !== 0) {
    writer.writeInt32(
      65,
      f
    );
  }
  f = message.getContentAccess();
  if (f != null) {
    writer.writeMessage(
      66,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string document_slug = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 document_id = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_title = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDisplayTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDisplayTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subtitle = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string abbreviation = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string icc_abbreviation = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIccAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIccAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string book_short_code = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getBookShortCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setBookShortCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string sku = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string pdf_url = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPdfUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPdfUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string shop_url = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getShopUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setShopUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string book_categories = 13;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getBookCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setBookCategoriesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.addBookCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearBookCategoriesList = function() {
  return this.setBookCategoriesList([]);
};


/**
 * repeated string category_slug = 14;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getCategorySlugList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setCategorySlugList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.addCategorySlug = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearCategorySlugList = function() {
  return this.setCategorySlugList([]);
};


/**
 * optional string document_url = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional DocumentType document_type = 16;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentType = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType, 16));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentType|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentType = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearDocumentType = function() {
  return this.setDocumentType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasDocumentType = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional ContentType content_type = 17;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentType = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType, 17));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentType|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentType = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearContentType = function() {
  return this.setContentType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasContentType = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional DocumentStatus document_status = 18;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentStatus = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus, 18));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.DocumentStatus|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentStatus = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearDocumentStatus = function() {
  return this.setDocumentStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasDocumentStatus = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool is_free_trial = 19;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsFreeTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsFreeTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool is_featured = 20;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsFeatured = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsFeatured = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool is_xml = 21;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsXml = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsXml = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool is_astm = 22;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsAstm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsAstm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool is_premium_pdf = 23;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsPremiumPdf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsPremiumPdf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool is_collection = 24;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsCollection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsCollection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string image_url = 25;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string print_info = 26;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPrintInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPrintInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string book_year = 27;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getBookYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setBookYear = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional bool access = 28;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional bool new_iccxml = 29;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getNewIccxml = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setNewIccxml = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * repeated BookCategory categories = 30;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getCategoriesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory, 30));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 30, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.addCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookCategory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional string link = 31;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional bool subscription_required = 32;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getSubscriptionRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setSubscriptionRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional int32 master_document_id = 33;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getMasterDocumentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setMasterDocumentId = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional int32 sort_order = 34;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional string print_version_month = 35;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPrintVersionMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPrintVersionMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string document_cover_pdf = 36;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentCoverPdf = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentCoverPdf = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional bool is_latest_version = 37;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsLatestVersion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsLatestVersion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional int32 latest_version_id = 38;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getLatestVersionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setLatestVersionId = function(value) {
  return jspb.Message.setProto3IntField(this, 38, value);
};


/**
 * optional bool serve_pdf_to_browser = 39;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getServePdfToBrowser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setServePdfToBrowser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional PrintVersionYear year = 40;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getYear = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} */ (
    jspb.Message.getWrapperField(this, icc_search_pb.PrintVersionYear, 40));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setYear = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearYear = function() {
  return this.setYear(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasYear = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional PrintVersionYear print_version_year = 41;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPrintVersionYear = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear} */ (
    jspb.Message.getWrapperField(this, icc_search_pb.PrintVersionYear, 41));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionYear|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPrintVersionYear = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearPrintVersionYear = function() {
  return this.setPrintVersionYear(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasPrintVersionYear = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional PrintVersionEdition print_version_edition = 42;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPrintVersionEdition = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition} */ (
    jspb.Message.getWrapperField(this, icc_search_pb.PrintVersionEdition, 42));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.PrintVersionEdition|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPrintVersionEdition = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearPrintVersionEdition = function() {
  return this.setPrintVersionEdition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasPrintVersionEdition = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional int32 associate_sort_order = 43;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getAssociateSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setAssociateSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 43, value);
};


/**
 * optional bool custom_toc = 44;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getCustomToc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 44, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setCustomToc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 44, value);
};


/**
 * optional string custom_toc_content = 45;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getCustomTocContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setCustomTocContent = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string document_keywords = 46;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDocumentKeywords = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDocumentKeywords = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional string book_abbr = 47;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getBookAbbr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setBookAbbr = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string description = 48;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional string effective_date = 49;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getEffectiveDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setEffectiveDate = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional TitleTopic title_topic = 50;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getTitleTopic = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic} */ (
    jspb.Message.getWrapperField(this, icc_search_pb.TitleTopic, 50));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.TitleTopic|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setTitleTopic = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearTitleTopic = function() {
  return this.setTitleTopic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasTitleTopic = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional bool is_master_book = 51;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsMasterBook = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 51, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsMasterBook = function(value) {
  return jspb.Message.setProto3BooleanField(this, 51, value);
};


/**
 * optional ContentAccessLevel content_access_level = 52;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentAccessLevel = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel, 52));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccessLevel|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentAccessLevel = function(value) {
  return jspb.Message.setWrapperField(this, 52, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearContentAccessLevel = function() {
  return this.setContentAccessLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasContentAccessLevel = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional string printing_text = 53;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPrintingText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPrintingText = function(value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * optional bool part_of_complete = 54;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getPartOfComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 54, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setPartOfComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 54, value);
};


/**
 * optional bool is_excluded = 55;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getIsExcluded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 55, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setIsExcluded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 55, value);
};


/**
 * optional bool has_landing_page = 56;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getHasLandingPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 56, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setHasLandingPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 56, value);
};


/**
 * optional bool supports_versions = 57;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getSupportsVersions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 57, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setSupportsVersions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 57, value);
};


/**
 * optional bool recently_added = 58;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getRecentlyAdded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 58, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setRecentlyAdded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 58, value);
};


/**
 * optional int32 content_access_level_id = 59;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentAccessLevelId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentAccessLevelId = function(value) {
  return jspb.Message.setProto3IntField(this, 59, value);
};


/**
 * optional string custom_code_profile_label = 60;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getCustomCodeProfileLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setCustomCodeProfileLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional bool content_restricted = 61;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentRestricted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 61, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentRestricted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 61, value);
};


/**
 * optional bool access_outside_trial = 62;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getAccessOutsideTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 62, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setAccessOutsideTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 62, value);
};


/**
 * optional int32 content_basic = 63;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentBasic = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentBasic = function(value) {
  return jspb.Message.setProto3IntField(this, 63, value);
};


/**
 * optional int32 content_premium = 64;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentPremium = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 64, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentPremium = function(value) {
  return jspb.Message.setProto3IntField(this, 64, value);
};


/**
 * optional int32 content_protection = 65;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentProtection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentProtection = function(value) {
  return jspb.Message.setProto3IntField(this, 65, value);
};


/**
 * optional ContentAccess content_access = 66;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.getContentAccess = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess, 66));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.ContentAccess|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.setContentAccess = function(value) {
  return jspb.Message.setWrapperField(this, 66, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.clearContentAccess = function() {
  return this.setContentAccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.prototype.hasContentAccess = function() {
  return jspb.Message.getField(this, 66) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
documentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string document_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoRequest.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
bookInfo: (f = msg.getBookInfo()) && proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.deserializeBinaryFromReader);
      msg.setBookInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional IccBookInfo book_info = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.prototype.getBookInfo = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.prototype.setBookInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.prototype.clearBookInfo = function() {
  return this.setBookInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetIccBookInfoResponse.prototype.hasBookInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
documentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addDocumentIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string document_ids = 1;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.prototype.getDocumentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.prototype.setDocumentIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.prototype.addDocumentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoRequest.prototype.clearDocumentIdsList = function() {
  return this.setDocumentIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
bookInfosList: jspb.Message.toObjectList(msg.getBookInfosList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.deserializeBinaryFromReader);
      msg.addBookInfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IccBookInfo book_infos = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.prototype.getBookInfosList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.prototype.setBookInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.prototype.addBookInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetMultipleIccBookInfoResponse.prototype.clearBookInfosList = function() {
  return this.setBookInfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.toObject = function(includeInstance, msg) {
  var f, obj = {
documentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
abbreviation: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbbreviation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string document_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string abbreviation = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.getAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.prototype.setAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
availableDocumentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
availableBooksList: jspb.Message.toObjectList(msg.getAvailableBooksList(),
    proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse;
  return proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAvailableDocumentIds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.deserializeBinaryFromReader);
      msg.addAvailableBooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailableDocumentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAvailableBooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string available_document_ids = 1;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.getAvailableDocumentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.setAvailableDocumentIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.addAvailableDocumentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.clearAvailableDocumentIdsList = function() {
  return this.setAvailableDocumentIdsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated BookMetadataBrief available_books = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief>}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.getAvailableBooksList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief>} value
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.setAvailableBooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief}
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.addAvailableBooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.BookMetadataBrief, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.io.icc.api.legacy.GetAvailableBookInfoResponse.prototype.clearAvailableBooksList = function() {
  return this.setAvailableBooksList([]);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.io.icc.api.legacy);
